/* =====================================================
   Equation Slot Component – Version 2.1 (Modified: July 31, 2025)
   Individual cells where numbers and operators are placed
   Date Modified: 31 July 2025 | Time: Current
===================================================== */

import { memo } from 'react'
import clsx from 'clsx'
import styles from './EquationSlot.module.css'

/**
 * Individual slot component for the equation grid
 * Displays numbers or operators with appropriate styling
 */
const EquationSlot = memo(function EquationSlot({ 
  slot, 
  rowIndex, 
  slotIndex, 
  expectedType 
}) {
  const isEmpty = !slot.value
  const isNumber = expectedType === 'number'
  const isOperator = expectedType === 'operator'
  
  const slotClasses = clsx(
    styles.slot,
    {
      [styles.numberSlot]: isNumber,
      [styles.operatorSlot]: isOperator,
      [styles.empty]: isEmpty,
      [styles.filled]: !isEmpty,
      [styles.correct]: slot.feedback === 'correct',
      [styles.incorrect]: slot.feedback === 'incorrect',
    }
  )

  return (
    <div 
      className={slotClasses}
      data-type={expectedType}
      data-index={slotIndex}
      data-row={rowIndex}
    >
      {slot.value}
    </div>
  )
})

export default EquationSlot